import React, { ReactNode } from 'react';
import _ from 'lodash';
// import { useLocation } from 'react-router-dom'

import {
  Row,
  Col,
  Form,
} from 'react-bootstrap';
// import styled from 'styled-components';
// import { up, down } from 'styled-breakpoints';

import { Divider } from "antd";

// Auth
// import { useAuthContext } from '../../../../v5/auth/use-auth-context.js';
// import { useRouter } from '../../../../v5/auth/auth-guard.js';

// Redux
import { useDispatch } from 'react-redux';
import { RootState, AppDispatch, useTypedSelector } from '../../../../v5/utils/store.tsx';
import slice, { useFormikContext, fields, weekDayNumb, isWeekend } from '../slice.tsx';

// enums
import { getDispatchUser, phoneNumberRegex } from '../../../../v5/utils/utils.tsx';
// import {  } from '../../../../v5/utils/enums.tsx';

// components
// import MainContainer from '../../../../v5/components/container/MainContainer.jsx';
import Dropzone from '../../../../v5/components/dropzone/Dropzone.tsx';

// import { ReactComponent as XIcon } from "../../../../v5/assets/icons/smallX.svg";

// ----------------------------------------------------------------------

const { 
  REACT_APP_DOC_GEN_API_URL
} = process.env;


const Signature = () => {
  // const location = useLocation();
  // const router = useRouter();
  
  let dispatchUser: any = getDispatchUser();
  let dispatchAccountId = (dispatchUser && dispatchUser.accountId) ? dispatchUser.accountId : null;

  const { values, errors, setValues, setFieldValue, validateForm, handleSubmit }: any = useFormikContext();

  const { isLoading } = useTypedSelector((state: RootState) => state.jobFormSlice);
  const dispatch = useDispatch<AppDispatch>();


  const getElements = () => {
    if(values.jobSignature && values.jobSignature.length > 0){
      return values.jobSignature.map((jobSignatureUrl: any, i: number) => {
        return <Col key={'jobform_signatures_item_' + i} xs={'auto'}>
          <Row className='g-16 align-items-center' style={{ maxWidth: '216px' }}>
            <Col xs={12}>
              <Dropzone
                accept={'image/jpeg,image/jpg,image/png'}
                acceptText={'.jpeg, .jpg, .png'}
                method={'post'}
                name={'file'}
                action={REACT_APP_DOC_GEN_API_URL + 'doc-generation-job/upload-file'}
                headers={{
                  'UploadPath': 'dispatch/' + dispatchAccountId + '/jobs/signature/attachment/',
                  'Authorization': 'mWU89QAnk0ik'
                }}
                maxCount={1}
                maxSize={null}
                multiple={false}
                showDownload={true}
                canCrop={false}
                bgWhite={true}
                files={jobSignatureUrl.jobSignatureUrl}
                onChange={({ fileList: newFileList }: any) => {
                  setFieldValue('jobSignature.' + i + '.jobSignatureUrl', newFileList);
                }}
                onRemoveFile={({ fileList: newFileList }: any) => {
                  setFieldValue('jobSignature.' + i + '.jobSignatureUrl', newFileList);
                }}
              />
            </Col>
            <Col xs={12}>
              <Row className='g-16 align-items-center'>
                <Col xs={12}>
                  <Form.Group>
                    <Form.Label disabled={true}>{fields.jobSignedUserName.label}</Form.Label>
                    <Form.Control
                      type={'text'}
                      autoComplete='off'
                      placeholder={fields.jobSignedUserName.placeholder}
                      disabled={false}
                      value={jobSignatureUrl.jobSignedUserName}
                      onChange={async (e) => {
                        await setFieldValue('jobSignature.' + i + '.jobSignedUserName', e.target.value);
                      }}
                      isInvalid={!!(errors && errors.jobSignature && errors.jobSignature[i] && errors.jobSignature[i].jobSignedUserName)}
                    />
                    <Form.Control.Feedback type="invalid">{(errors && errors.jobSignature && errors.jobSignature[i] && errors.jobSignature[i].jobSignedUserName) && errors.jobSignature[i].jobSignedUserName}</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12}>
                  <Form.Group>
                    <Form.Label disabled={true}>{fields.jobSignedUserContact.label}</Form.Label>
                    <Form.Control
                      type={'text'}
                      autoComplete='off'
                      placeholder={fields.jobSignedUserContact.placeholder}
                      disabled={false}
                      value={jobSignatureUrl.jobSignedUserContact}
                      onChange={async (e) => {
                        if (e.target.value === '' || phoneNumberRegex().test(e.target.value)) {
                          await setFieldValue('jobSignature.' + i + '.jobSignedUserContact', e.target.value);
                        }
                      }}
                      isInvalid={!!(errors && errors.jobSignature && errors.jobSignature[i] && errors.jobSignature[i].jobSignedUserContact)}
                    />
                    <Form.Control.Feedback type="invalid">{(errors && errors.jobSignature && errors.jobSignature[i] && errors.jobSignature[i].jobSignedUserContact) && errors.jobSignature[i].jobSignedUserContact}</Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      });
    }
  }

  return <>
    {(values.jobSignature && values.jobSignature.length > 0) && <Col xs={12} xxl={10}>
      <Row className='gy-16 align-items-center'>
      <Col xs={12}>
          <span className="large semibold gray-900">8. Signature</span>
        </Col>

        <Col xs={12}>
          <Row className='g-32'>{getElements()}</Row>
        </Col>
        
        <Col xs={12}>
          <Divider />
        </Col>
      </Row>
    </Col>}
  </>
}

export default Signature;
